import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import Button2 from 'components/buttons/Button2/Button2';
import { LOGIN_FORM_TYPES } from 'constants/Login';
import AuthenticationLayout from 'components/templates/AuthenticationLayout/AuthenticationLayout';
import _get from 'lodash/get';
import { useSelector, useDispatch } from 'react-redux';
import Message2 from 'components/messages/Message2';
import SignIn from './components/SignIn/SignIn';
import SignUp from './components/SignUp/SignUp';
import Recover from './components/Recover/Recover';

const FormContainer = ({
  formType,
  handleFormTypeChange,
  query,
  pathname,
}) => {
  const { formatMessage: t } = useIntl();

  const dispatch = useDispatch();

  const resetSignUp = () => dispatch({
    type: 'SIGN_UP',
    status: null,
  });

  const resetRecoverPassword = () => dispatch({
    type: 'RECOVER_PASSWORD',
    status: null,
  });

  let RedirectionButton = null;
  let Form = null;
  let title = null;
  let subtitle = null;

  let Message = null;

  /* Reset messages when switching form or quitting window */
  /* ----------------------------------------------------- */
  // useEffect(() => {
  //   if (formType && formType !== 'signup') resetSignUp();
  // }, [formType]);

  useEffect(() => {
    window.addEventListener('beforeunload', resetSignUp);
    window.addEventListener('beforeunload', resetRecoverPassword);
    return () => {
      window.removeEventListener('beforeunload', resetSignUp);
      window.removeEventListener('beforeunload', resetRecoverPassword);
    };
  }, []);

  /* 1️⃣ Sign up */
  /* ---------- */

  const signUp = useSelector((state) => _get(state, 'auth.signUp', null));

  /* ❌ Error */
  /* -------- */
  if (signUp === 'INVALID' || signUp === 'EXPIRED') {
    Message = (
      <Message2
        type="alert"
        title={t({ id: 'message.title.expiredValidationAccountLink' })}
        onClose={resetSignUp}
      >
        {t({ id: 'message.description.expiredValidationAccountLink' })}
      </Message2>
    );
  }
  /* ⏳ Waiting validation */
  /* --------------------- */
  if (signUp === 'WAITING_EMAIL_VALIDATION') {
    Message = (
      <Message2
        type="success"
        title={t({ id: 'message.title.accountCreated' })}
        onClose={resetSignUp}
      >
        {t({ id: 'message.login.signupSuccessWaitConfirmation' })}
      </Message2>
    );
  }

  /* ✅ Success */
  /* ---------- */
  if (signUp === 'OK_NO_VALIDATION') {
    Message = (
      <Message2
        type="success"
        title={t({ id: 'message.title.accountCreated' })}
        onClose={resetSignUp}
      >
        {t({ id: 'message.login.signupSuccess' })}
      </Message2>
    );
  }

  /* 2️⃣ Recover password */
  /* ------------------- */
  const recoverPassword = useSelector((state) => _get(state, 'auth.recoverPassword', null));

  /* ✅ Success */
  /* ---------- */

  if (recoverPassword === 'GET_LINK') {
    Message = (
      <Message2
        type="success"
        onClose={resetRecoverPassword}
        title={t({ id: 'message.title.sendInstructions' })}
      >
        {t({ id: 'message.description.sendInstructions' })}
      </Message2>
    );
  }

  if (recoverPassword === 'UPDATED') {
    Message = (
      <Message2
        type="success"
        onClose={resetRecoverPassword}
        title={t({ id: 'message.title.recoveredPassword' })}
      >
        {t({ id: 'message.description.recoveredPassword' })}
      </Message2>
    );
  }

  /* ---------------------------------------------- */

  switch (formType) {
    case LOGIN_FORM_TYPES.SIGNIN:
      RedirectionButton = (
        <Button2 type="primaryOutline" size="small" onClick={() => handleFormTypeChange(LOGIN_FORM_TYPES.SIGNUP)}>
          {t({ id: 'button.createAccount' })}
        </Button2>
      );
      Form = <SignIn handleFormTypeChange={handleFormTypeChange} />;
      title = t({ id: 'button.signInMyself' });
      subtitle = t({ id: 'subtitle.signIn' });
      break;

    case LOGIN_FORM_TYPES.SIGNUP:
      RedirectionButton = (
        <Button2 type="primaryOutline" size="small" onClick={() => handleFormTypeChange(LOGIN_FORM_TYPES.SIGNIN)}>
          {t({ id: 'button.login' })}
        </Button2>
      );
      title = t({ id: 'title.accountCreation' });
      Form = <SignUp query={query} pathname={pathname} handleFormTypeChange={handleFormTypeChange} />;
      break;

    case LOGIN_FORM_TYPES.FORGOT_PASSWORD:
      RedirectionButton = (
        <Button2 type="primaryOutline" size="small" onClick={() => handleFormTypeChange(LOGIN_FORM_TYPES.SIGNIN)}>
          {t({ id: 'button.login' })}
        </Button2>
      );
      title = t({ id: 'title.resetPassword' });
      subtitle = t({ id: 'subtitle.resetPassword' });
      Form = <Recover handleFormTypeChange={handleFormTypeChange} />;
      break;

    default:
      break;
  }
  return (
    <AuthenticationLayout
      title={title}
      subtitle={subtitle}
      Message={Message}
      RedirectionButton={RedirectionButton}
    >
      {Form}
    </AuthenticationLayout>
  );
};

FormContainer.propTypes = {
  query: PropTypes.shape({
    link: PropTypes.string,
  }),
  pathname: PropTypes.string,
  formType: PropTypes.string.isRequired,
  handleFormTypeChange: PropTypes.func.isRequired,
};

FormContainer.defaultProps = {
  query: {
    link: null,
  },
  pathname: null,
};

module.exports = FormContainer;



// WEBPACK FOOTER //
// ./routes/login/components/cpm_client/FormContainer.jsx